import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { checkTokenExpiration } from './features/auth/checkTokenExpiration';
import { logout } from './features/auth/authSlice';
import { clear } from './features/auth/authAPI';
import BorrowerDashboard from "./pages/profile/BorrowerDashboard";
import LoanRequestBoard from "./request/loan/LoanRequestBoard";
import MainLandingPage from "./figma/design/MainLandingPage";
import CreditRequestPage from "./request/CreditRequestPage";
import BorrowerBenefits from "./figma/BorrowerBenefits";
import LenderBenefits from "./figma/LenderBenefits";
import Dashboard from "./pages/dashboard/Dashboard";
import LoanBoard from "./request/loan/LoanBoard";
import About from "./figma/design/About";
import Register from "./pages/Register";
import Header from "./request/Header";
import Footer from "./request/Footer";
import Login from "./pages/Login";
import UserNetwork from "./board/UserNetwork";
import UserFund from "./board/UserFund";
import UserCard from "./board/UserCard";
import UserUser from "./board/UserUser";
import UserNot from "./board/UserNot";
import Log from "./board/Log";
import Board from "./board/Board";
import Dash from "./board/Dash";

function App() {
    const noHeaderFooterPaths = ["/", "/un", "/uf", "/uc", "/ut", "/uu", "/dash", "/board", "/dashboard"];
    const username = useSelector((state) => state.auth.username);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (checkTokenExpiration()) {
            dispatch(logout());
            dispatch(clear());
            navigate("/login", { replace: true });
        }
    }, [navigate]);

    return (
        <main className="flex overflow-hidden flex-col bg-zinc-900 bg-slate-950 rounded-[0px]">
            {!noHeaderFooterPaths.includes(location.pathname) && <Header />}
            <Routes>
                <Route index element={<MainLandingPage />} />
                <Route path="/user/:username" element={username ? <BorrowerDashboard /> : <Navigate to="/login" replace={true} />} />
                <Route path="/repay" element={username ? <LoanBoard /> : <Navigate to="/login" replace={true} />} />
                <Route path="/get" element={username ? <LoanRequestBoard /> : <Navigate to="/login" replace={true} />} />
                <Route path="/profile" element={username ? <Dashboard /> : <Navigate to="/login" replace={true} />} />
                <Route path="/guide" element={<About />} />
                <Route path="/whylend" element={<LenderBenefits />} />
                <Route path="/benefits" element={<BorrowerBenefits />} />
                <Route path="/dashboard" element={username ? <CreditRequestPage /> : <Navigate to="/login" replace={true} />} />
                <Route path="/register" element={username ? <Navigate to="/dashboard" replace={true} /> : <Register />} />
                <Route path="/login" element={username ? <Navigate to="/dashboard" replace={true} /> : <Login />} />
                <Route path="*" element={<Navigate to={username ? "/dashboard" : "/login"} replace={true} />} />
                <Route path="/un" element={<UserNetwork />} />
                <Route path="/uf" element={<UserFund />} />
                <Route path="/uc" element={<UserCard />} />
                <Route path="/uu" element={<UserUser />} />
                <Route path="/ut" element={<UserNot />} />
                <Route path="/log" element={<Log />} />
                <Route path="/board" element={<Board />} />
                <Route path="/dash" element={<Dash />} />
            </Routes>
            {!noHeaderFooterPaths.includes(location.pathname) && <Footer />}
        </main>
    );
};

export default App;
